// extracted by mini-css-extract-plugin
export default {"lead":"AboutSection_lead__L0pZ5"};